import { apiConfig } from "../helpers";
import { authHeader } from '../helpers';
import axios from 'axios';

export const visitService = {
    create,
    GetPatientVisitDetails,
    UpdatePatientvisitDetails,
    GetNearVisits,
    GetCurrentVisits,
    GetPastVisits,
    CancelVisit,
    CloseVisit,
    OpenVisit,
    AddPayment,
    UpdatePayment,
    DeletePayment,
    ListPaginatedVisits,
    UpdateVisitProcess,
    ConfirmVisit,
    GetSMSDailyStatus,
    GetVisitSMSStatus,
    GetTherapistVisitDetails,
    GetTherapistPreviousVisit,
    GetVisitsHistory,
    CheckVisitTimeStatus,
    AddVisitProcedure,
    DeleteVisitProcedure,
    DeleteVisitCondition,
    AddVisitCondition,
    VerifyVisitP1,
    GetVisitsP1Status,
    retryP1Visit,
    listVisits,
    getWolneTerminyZabiegu,
    insertZleconyZabieg,
    getZleconeZabiegi,
    deleteZleconyZabieg,
    getPodsumowaniePacjenta,
    UpdateTypWizytyCzasWizyty,
    SendInvitationVisit,
    PacjentObecnyNieobecny,
    SetNieWysylajSMS,
    getSMSVisits,
    shiftVisit,
    getVisitsSummaryForSms,
    sendSMS,
    SetPayByPayu,
    checkRegularVisit,
    ConfirmPortalVisit,
    CancelPortalVisit,
    // SMS Center
    getSMSCenterList,
    markSMSAsRead,
    getUnreadSMSCount
};


function create(data)
{
    return axios.post('/api/services/app/Visit/CreatePatientVisit',data, {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),           
    })
}
function GetPatientVisitDetails(id)
{
    return axios.get('/api/services/app/Visit/GetPatientVisitDetails', {      
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
        params: {
            id: id
        }
    })         
}
function UpdatePatientvisitDetails(data)
{
    return axios.put('/api/services/app/Visit/UpdatePatientvisitDetails',data, {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),           
    })        
}
function GetNearVisits(cnt)
{
    return axios.get('/api/services/app/Visit/GetNearVisits', {      
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
        params: {
            cnt: cnt
        }
    })     
}
function GetCurrentVisits()
{
    return axios.get('/api/services/app/Visit/GetCurrentVisits', {      
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),        
    })     
}
function GetPastVisits()
{
    return axios.get('/api/services/app/Visit/GetPastVisits', {      
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),        
    })     
}
function CancelVisit(id,reason,sub_type)
{    
    
    return axios.post('/api/services/app/Visit/CancelVisit',{
        id: id,
        reason: reason,
        status_subtype: sub_type, 
    }, {      
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),      
    })    
}
function CloseVisit(id,opinion = false)
{
    return axios.post('/api/services/app/Visit/CloseVisit', { id: id,  sent_opinion: opinion}, {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),        
    })    
}
function OpenVisit(id)
{
    return axios.post('/api/services/app/Visit/OpenVisit', { id: id }, {      
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),        
    })    
}
function AddPayment(data)
{
    return axios.post('/api/services/app/Visit/AddPayment',data, {      
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),        
    }) 
}
function UpdatePayment(data)
{
    return axios.put('/api/services/app/Visit/UpdatePayment',data, {      
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),        
    }) 
}
function DeletePayment(id)
{
    return axios.delete('/api/services/app/Visit/DeletePayment', {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
        params: {
            Id: id
        }           
    })    
}
function ListPaginatedVisits(data)
{
    return axios.post('/api/services/app/Visit/ListVisitsPagination',data, {      
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),        
    }) 
}
function UpdateVisitProcess(data)
{
    return axios.put('/api/services/app/Visit/UpdateVisitProcess',data, {      
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),        
    }) 
}
function ConfirmVisit(id)
{
    return axios.post('/api/services/app/Visit/ConfirmVisit', { id: id }, {      
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),        
    })    
}
function GetSMSDailyStatus()
{
    return axios.get('/api/services/app/Visit/GetSMSDailyStatus', {      
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),        
    })    
}
function GetVisitSMSStatus(id)
{
    return axios.get('/api/services/app/Visit/GetVisitSMSStatus', {      
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
        params: {
            visitid: id
        }
    })         
}
function GetTherapistVisitDetails(id)
{
    return axios.get('/api/services/app/Visit/GetTherapistVisitDetails', {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
        params: {
            id: id
        }
    })
}
function GetTherapistPreviousVisit(id)
{
    return axios.get('/api/services/app/Visit/GetTherapistPreviousVisit', {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
        params: {
            id: id
        }
    })
}
function GetVisitsHistory(data,onlyclosed)
{
    let params = {
        Keyword: data.query,
            SkipCount: (data.page-1) * data.limit,
            MaxResultCount: data.limit,
            Sorting: data.sorting,
            clientID: data.clientID,
            startDate: data.startDate,
            endDate: data.endDate,
            status: data.status,
            statusSubType: data.statusSubtype
    };
    if(onlyclosed)
    {
        params['status'] = 3
    }
    return axios.post('/api/services/app/Visit/ListVisitHistory',params, {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
    })
}
function CheckVisitTimeStatus(data)
{
    return axios.post('/api/services/app/Visit/CheckVisitTimeStatus',data, {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
    })
}
function AddVisitProcedure(data)
{
    return axios.post('/api/services/app/Visit/AddVisitProcedure',data, {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
    })
}
function  DeleteVisitProcedure(id)
{
    return axios.delete('/api/services/app/Visit/DeleteVisitProcedure', {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
        params: {
            id: id
        }
    })
}
function AddVisitCondition(data)
{
    return axios.post('/api/services/app/Visit/AddVisitCondition',data, {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
    })
}
function  DeleteVisitCondition(id)
{
    return axios.delete('/api/services/app/Visit/DeleteVisitCondition', {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
        params: {
            id: id
        }
    })
}
function VerifyVisitP1(id)
{
    return axios.get('/api/services/app/P1Service/GetVerifyVisit', {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
        params: {
            visitID: id
        }
    })
}
function GetVisitsP1Status()
{
    return axios.get('/api/services/app/Visit/GetVisitsP1Status', {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
    })
}
function retryP1Visit(id)
{
    return axios.post('/api/services/app/Visit/RetryP1Visit', { id: id }, {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
    })
}
function listVisits(data)
{
    return axios.post('/api/services/app/Visit/ListVisits',data, {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),

    })
}
function getWolneTerminyZabiegu(data)
{
    return axios.get('/api/services/app/Visit/GetWolneTerminyZabiegu', {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
        params: data
    })
}
function insertZleconyZabieg(data)
{
    return axios.post('/api/services/app/Visit/InsertZleconyZabieg',data, {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),

    })
}
function getZleconeZabiegi(id)
{
    return axios.get('/api/services/app/Visit/GetZleconeZabiegi', {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
        params: {
            id: id
        }
    })
}
function deleteZleconyZabieg(id)
{
    return axios.delete('/api/services/app/Visit/DeleteZleconyZabieg', {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
        params: {
            id: id
        }
    })
}
function getPodsumowaniePacjenta(params)
{
    return axios.get('/api/services/app/Visit/getPodsumowaniePacjenta', {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
        params: params
    })
}
function UpdateTypWizytyCzasWizyty(data)
{
    return axios.put('/api/services/app/Visit/UpdateTypWizytyCzasWizyty',data, {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
    })
}
function SendInvitationVisit(data)
{
    return axios.post('/api/services/app/Visit/SendInvitationVisit', data, {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),        
    })
}
function PacjentObecnyNieobecny(visitid)
{
    return axios.post('/api/services/app/Visit/PacjentObecnyNieobecny', {}, {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
        params: {
            visitid: visitid
        }

    })
}
function SetNieWysylajSMS(visitid)
{
    return axios.post('/api/services/app/Visit/SetNieWysylajSMS', {}, {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
        params: {
            visitid: visitid
        }

    })
}
function getSMSVisits()
{
    return axios.get('/api/services/app/Visit/GetSMSVisits', {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
    })
}
function shiftVisit(data)
{
    return axios.post('/api/services/app/Visit/ShiftVisit',data, {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
    })
}
function getVisitsSummaryForSms(start,end)
{
    return axios.get('/api/services/app/Visit/GetVisitsSummaryForSms', {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
        params: {
            start: start,
            end: end
        }
    })
}
function sendSMS(data)
{
    return axios.post('/api/services/app/Visit/SendSMS',data, {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
    })
}
function SetPayByPayu(visitid)
{
    return axios.post('/api/services/app/Visit/SetPayByPayu', {}, {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
        params: {
            visitid: visitid
        }
    });
}
function checkRegularVisit(data)
{
    return axios.post('/api/services/app/Visit/CheckRegularVisit', data, {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
    })
}
function ConfirmPortalVisit(visitId)
{
    return axios.post('/api/services/app/Visit/ConfirmPortalVisit', {}, {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
        params: {
            visitId: visitId
        }
    });
}
function CancelPortalVisit(visitId, reason)
{
    return axios.post('/api/services/app/Visit/CancelPortalVisit', {}, {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
        params: {
            visitId: visitId,
            reason: reason
        }
    });
}

// SMS Center functions
function getSMSCenterList(filter)
{
    return axios.get('/api/services/app/SMSCenter/GetAll', {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
        params: {
            ClientId: filter.clientId,
            VisitId: filter.visitId,
            OnlyUnread: filter.onlyUnread,
            DateFrom: filter.dateFrom,
            DateTo: filter.dateTo,
            SkipCount: filter.skipCount,
            MaxResultCount: filter.maxResultCount
        }
    });
}

function markSMSAsRead(id, source)
{
    return axios.post('/api/services/app/SMSCenter/MarkAsRead', { id, source }, {
        baseURL: apiConfig.apiUrl,
        headers: authHeader()
    });
}

function getUnreadSMSCount()
{
    return axios.get('/api/services/app/SMSCenter/GetUnreadCount', {
        baseURL: apiConfig.apiUrl,
        headers: authHeader()
    });
}